import { Comment } from "../../../../models"
import { isExistComment, withUpdateComment } from "../../../../utils"
import { ErrorFetchingAction, FetchErrorInfo, FetchRequestActions, StartFetchingAction, SuccessFetchingAction } from "../../../../utils/request-actions-helpers/createRequestActions"
import { deleteCommentActionTypes, DeleteCommentAdditionalData } from "./actions/deleteComment"
import { GetCommentsAdditionalData, getCommentsForDocumentActionTypes, getChatCommentsForDocumentActionTypes } from "./actions/getCommentsForDocument"
import { postCommentActionTypes, PostCommentAdditionalData } from "./actions/postComment"
import {getUpdateLastUserEnterChatDiscussionsActionTypes} from './actions/updateLastUserEnterChat';
import {UPDATE_LATEST_COMMENT, UpdateLatestCommentAction} from './actions/updateLatestComment';
export interface CommentState {
    item: Comment
    isDeleting: boolean
    deleteError?: FetchErrorInfo
}

export interface DocumentCommentsState {
    comments: CommentState[]
    isFetching: boolean
    isPosting: boolean
    isFetchingMore?: boolean
    commentsPage?: number
    hasMoreComments?: boolean
    fetchError?: FetchErrorInfo
    postError?: FetchErrorInfo
}

export interface CommentsState {
    data: {
        [docId: string]: DocumentCommentsState | undefined
    }
}

const initialDocumentCommentsState: DocumentCommentsState = {
    comments: [],
    isFetching: false,
    isPosting: false,
    isFetchingMore: false,
    commentsPage: 0,
    hasMoreComments: false
}

export const initialCommentsState: CommentsState = {
    data: {}
}
export const commentsReducer = (state: CommentsState = initialCommentsState, action: FetchRequestActions<Comment[], GetCommentsAdditionalData> | UpdateLatestCommentAction): CommentsState => {
    switch (action.type) {
        case UPDATE_LATEST_COMMENT: {
            const latestCommentAction = action as UpdateLatestCommentAction;

            const {docId, comment} = latestCommentAction
            const documentComments = (state.data[docId] || { ...initialDocumentCommentsState })

            const prevComments = documentComments?.comments;
            const existComment = isExistComment(comment.commentId, prevComments);

            if(existComment){
                return state;
            }
            
            const commentState: CommentState = {
                item: comment,
                isDeleting: false
            }
            
            let newData: DocumentCommentsState = {
                ...documentComments,
                comments:  [commentState, ...documentComments.comments]
            }

            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [docId]: newData
                }
            }
            return newState 

        }
        case getUpdateLastUserEnterChatDiscussionsActionTypes.start: {
            return state
        }
        case getUpdateLastUserEnterChatDiscussionsActionTypes.success: {
            return state
        }
        case getUpdateLastUserEnterChatDiscussionsActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<GetCommentsAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { docId } = errorAction.additionalData
            const documentComments = state.data[docId] || { ...initialDocumentCommentsState }
            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [errorAction.additionalData.docId]: {
                        ...documentComments,
                        fetchError: errorAction.error
                    }
                }
            }
            return newState
        }
        case getChatCommentsForDocumentActionTypes.start: {
            const startFetchingAction = action as StartFetchingAction<GetCommentsAdditionalData>
            if (!startFetchingAction.additionalData) {
                return state
            }
            const newState: CommentsState = {
                data: {
                    ...state.data
                }
            }
            const {docId, commentsPage} = startFetchingAction.additionalData
          
            const documentCommmentsState = state.data[docId] || { ...initialDocumentCommentsState }
            newState.data[docId] = {
                ...documentCommmentsState,
                isFetching: commentsPage as number === 0,
                isFetchingMore: commentsPage as number > 0 
            }

            return newState   
        }
        case getChatCommentsForDocumentActionTypes.success: {
            const successAction = action as SuccessFetchingAction<Comment[], GetCommentsAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const {docId, commentsPage} = successAction.additionalData
            const documentComments = (state.data[docId] || { ...initialDocumentCommentsState })

            const resultComments = successAction.result.map(x => {
                const commentState: CommentState = {
                    item: x,
                    isDeleting: false
                }
                return commentState
            })
            const newComments = [ ...resultComments,...documentComments.comments,];
            const hasMoreComments = commentsPage === 0 && resultComments.length < 60 ? false : resultComments.length > 0
            
            let newData: DocumentCommentsState = {
                ...documentComments,
                isFetching: false,
                isFetchingMore: false,
                hasMoreComments: hasMoreComments,
                commentsPage,
                comments:  commentsPage as number > 0 ? newComments : resultComments
            }

            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [docId]: newData
                }
            }
            return newState 
        }
        case getChatCommentsForDocumentActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<GetCommentsAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { docId } = errorAction.additionalData
            const documentComments = state.data[docId] || { ...initialDocumentCommentsState }
            if (errorAction.error.message === 'aborted') {
                return {
                    ...state,
                    data: {
                        ...state.data,
                        [errorAction.additionalData.docId]: {
                            ...documentComments,
                            isFetching: false,
                        }
                    }
                }
            }
            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [errorAction.additionalData.docId]: {
                        ...documentComments,
                        isFetching: false,
                        comments: [],
                        fetchError: errorAction.error
                    }
                }
            }
            return newState
        }
        case getCommentsForDocumentActionTypes.start: {
            const startFetchingAction = action as StartFetchingAction<GetCommentsAdditionalData>
            if (!startFetchingAction.additionalData) {
                return state
            }
            const newState: CommentsState = {
                data: {
                    ...state.data
                }
            }
            const docId = startFetchingAction.additionalData.docId
            const documentCommmentsState = state.data[docId] || { ...initialDocumentCommentsState }
            newState.data[docId] = {
                ...documentCommmentsState,
                isFetching: true
            }

            return newState
        }
        case getCommentsForDocumentActionTypes.success: {
            const successAction = action as SuccessFetchingAction<Comment[], GetCommentsAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const docId = successAction.additionalData.docId
            const documentComments = state.data[docId] || { ...initialDocumentCommentsState }
            let newData: DocumentCommentsState = {
                ...documentComments,
                isFetching: false,
                comments: successAction.result.map(x => {
                    const commentState: CommentState = {
                        item: x,
                        isDeleting: false
                    }
                    return commentState
                })
            }

            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [docId]: newData
                }
            }
            return newState
        }
        case getCommentsForDocumentActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<GetCommentsAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { docId } = errorAction.additionalData
            const documentComments = state.data[docId] || { ...initialDocumentCommentsState }
            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [errorAction.additionalData.docId]: {
                        ...documentComments,
                        isFetching: false,
                        comments: [],
                        fetchError: errorAction.error
                    }
                }
            }
            return newState
        }
        case deleteCommentActionTypes.start: {
            const startDeletingAction = action as StartFetchingAction<DeleteCommentAdditionalData>
            if (!startDeletingAction.additionalData) {
                return state
            }
            const { commentId, docId } = startDeletingAction.additionalData
            const documentComments = state.data[docId]
            if (!documentComments) {
                return state
            }

            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [docId]: {
                        ...documentComments,
                        comments: documentComments.comments.map(x => {
                            if (x.item.commentId !== commentId) {
                                return x
                            }
                            const newCommentState: CommentState = {
                                isDeleting: true,
                                item: x.item
                            }
                            return newCommentState
                        })
                    }
                }
            }
            return newState
        }
        case deleteCommentActionTypes.error: {
            const errorDeletingAction = action as ErrorFetchingAction<DeleteCommentAdditionalData>
            if (!errorDeletingAction.additionalData) {
                return state
            }
            const { commentId, docId } = errorDeletingAction.additionalData
            const documentComments = state.data[docId]
            if (!documentComments) {
                return state
            }
            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [docId]: {
                        ...documentComments,
                        isFetching: false,
                        comments: documentComments.comments.map(x => {
                            if (x.item.commentId !== commentId) {
                                return x
                            }

                            const newCommentState: CommentState = {
                                isDeleting: false,
                                item: x.item,
                                deleteError: errorDeletingAction.error
                            }
                            return newCommentState
                        })
                    }
                }
            }

            return newState
        }
        case deleteCommentActionTypes.success: {
            const successfullyDeletedAction = action as SuccessFetchingAction<never, DeleteCommentAdditionalData>
            if (!successfullyDeletedAction.additionalData) {
                return state
            }
            const { commentId, docId } = successfullyDeletedAction.additionalData
            const documentComments = state.data[docId]
            if (!documentComments) {
                return state
            }

            const newState: CommentsState = {
                data: {
                    ...state.data,
                    [docId]: {
                        ...documentComments,
                        isFetching: false,
                        comments: documentComments.comments.filter(x => x.item.commentId !== commentId)
                    }
                }
            }
            return newState
        }
        case postCommentActionTypes.start: {
            const postAction = action as StartFetchingAction<PostCommentAdditionalData>
            if (!postAction.additionalData) {
                return state
            }
            const { docId,newUsage,tempComment } = postAction.additionalData
            
            const documentComments = state.data[docId] || { ...initialDocumentCommentsState }

            if(!!newUsage) {
                if(!!tempComment) {
                    documentComments.comments.push(tempComment)
                    return {
                        data: {
                            ...state.data,
                            [docId]: {
                                ...documentComments,
                                isPosting: true,
                                comments:   [
                                    ...documentComments.comments,
                                ]
                            }
                        }
                    }
                } else {
                    return {
                        data: {
                            ...state.data,
                            [docId]: {
                                ...documentComments,
                                isPosting: true
                            }
                        }
                    }
                }
            }

            return {
                data: {
                    ...state.data,
                    [docId]: {
                        ...documentComments,
                        isPosting: true
                    }
                }
            }
        }
        case postCommentActionTypes.success: {
            const successPosting = action as SuccessFetchingAction<Comment, PostCommentAdditionalData>
            if (!successPosting.additionalData) {
                return state
            }

            const { docId } = successPosting.additionalData
            const documentComments = state.data[docId] || { ...initialDocumentCommentsState }
            
            const prevComments = documentComments?.comments;
            if(!!successPosting.additionalData.newUsage) {
                    const existComment = isExistComment(successPosting.result.commentId, prevComments, successPosting.additionalData.tempId);
    
                    return {
                        data: {
                            ...state.data,
                            [docId]: {
                                ...documentComments,
                                isPosting: false,
                                comments: existComment ? [...withUpdateComment(prevComments, successPosting.result, successPosting.additionalData.tempId)] : [
                                    ...documentComments.comments,
                                    { item: successPosting.result, isDeleting: false }
                                ]
                            }
                        }
                    }
                }
            const existComment = isExistComment(successPosting.result.commentId, prevComments);

            return {
                data: {
                    ...state.data,
                    [docId]: {
                        ...documentComments,
                        isPosting: false,
                        comments: existComment ? [...withUpdateComment(prevComments, successPosting.result)] : [
                            ...documentComments.comments,
                            { item: successPosting.result, isDeleting: false }
                        ]
                    }
                }
            }
        }
        case postCommentActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<PostCommentAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { docId } = errorAction.additionalData
            const documentComments = state.data[docId] || { ...initialDocumentCommentsState }

            return {
                data: {
                    ...state.data,
                    [docId]: {
                        ...documentComments,
                        isPosting: false,
                        postError: errorAction.error
                    }
                }
            }
        }
        default:
            return state
    }
}